if (!customElements.get('qp-video-access')) {
  customElements.define('qp-video-access', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const dialog = this.querySelector('.qp-video-dialog');
      const player = this.querySelector('[data-video-player]');
      let opener;
      let overflow;
      const cleanup = () => {
        player.replaceChildren();
        document.body.style.overflow = overflow ?? '';
        if (opener?.isConnected) opener.focus({preventScroll: true});
      };
      const showVideo = button => {
        const template = this.querySelector(`[data-video-template="${button.dataset.videoOpen}"]`);
        if (!template) return;
        if (!dialog.open) {
          opener = button;
          overflow = document.body.style.overflow;
          dialog.showModal();
          document.body.style.overflow = 'hidden';
        }
        player.replaceChildren(template.content.cloneNode(true));
        this.querySelector('[data-video-close]').focus({preventScroll:true});
      };
      this.querySelectorAll('[data-video-open]').forEach(button => {
        button.addEventListener('click', () => showVideo(button), {signal});
      });
      const chooserButton = this.querySelector('[data-video-chooser-open]');
      chooserButton?.addEventListener('click', () => {
        if (dialog.open) return;
        opener = chooserButton;
        overflow = document.body.style.overflow;
        const choices = document.createElement('div');
        choices.className = 'qp-video-choices';
        this.querySelectorAll('.qp-video-access-list>[data-video-open]').forEach(source => {
          const choice = source.cloneNode(true);
          choice.addEventListener('click', () => showVideo(source));
          choices.append(choice);
        });
        player.replaceChildren(choices);
        dialog.showModal();
        document.body.style.overflow = 'hidden';
      }, {signal});
      this.querySelector('[data-video-close]').addEventListener('click', () => dialog.close(), {signal});
      dialog.addEventListener('close', cleanup, {signal});
      this.mobileEntry = chooserButton || this.mobileEntry;
      this.dispose = () => { if (dialog.open) { dialog.close(); cleanup(); } };
    }
    disconnectedCallback() { this.dispose?.(); this.abort?.abort(); }
  });
}

